export default {
  tablet: 'min-width: 568px',
  tabletL: 'min-width: 980px',
  desktopM: 'min-width: 1024px',
  desktop: 'min-width: 1080px',
  desktopL: 'min-width: 1440px',
};
